<template>
  <v-container fluid grid-list-lg>
    <page-loading v-show="loading"></page-loading>
    <transition name="fade-transition">
      <div v-if="pagina !== undefined">
        <h3 class="headline">{{ pagina.titlu }}</h3>
        <div v-html="pagina.continut" class="mt-3"></div>
      </div>
    </transition>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {find} from '@/modules/pagini/index.js';
import kw from '@/modules/pagini/lang/index.js';

export default {
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      pagina: undefined
    }
  },
  computed: {
    ...mapGetters(['language']),
    keywords() {
      return kw[this.language];
    }
  },
  methods: {
    load() {
      this.loading = true;

      return find(this.language, this.slug)
          .then(response => response.json()
              .then(payload => {
                this.pagina = payload.data;
              })
          )
          .catch(e => {
            console.log(e);
          })
          .then(() => {
            this.loading = false;
          });
    }
  },
  watch: {
    slug: {
      handler() {
        this.load();
      },
      immediate: true
    }
  }
};
</script>
